import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { Info } from 'react-feather';
import { getFullVersion, getBuildInfo, getEnvironmentDebugInfo } from '../../config/version';

const VersionDisplay = () => {
  const buildInfo = getBuildInfo();
  const debugInfo = getEnvironmentDebugInfo();
  
  // Debug logging to help troubleshoot environment detection
  console.log('🔍 Environment Debug Info:', debugInfo);
  
  const isProduction = buildInfo.environment === 'production';
  const isQA = buildInfo.environment === 'qa';
  
  const versionTooltip = (
    <div>
      <div><strong>Version:</strong> {buildInfo.version}</div>
      <div><strong>Build:</strong> {buildInfo.buildNumber}</div>
      <div><strong>Date:</strong> {buildInfo.buildDate}</div>
      <div><strong>Environment:</strong> {buildInfo.environment}</div>
    </div>
  );

  return (
    <Box className="version-display-wrapper">
      <Tooltip 
        arrow 
        title={versionTooltip}
        placement="top"
      >
        <Box 
          className="version-display"
          style={{
            backgroundColor: isProduction 
              ? 'rgba(0, 128, 0, 0.8)' 
              : isQA 
                ? 'rgba(255, 165, 0, 0.8)' 
                : 'rgba(255, 0, 0, 0.8)',
            color: 'black',
            padding: '8px 16px',
            margin: '4px 0',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '0.8rem',
            minHeight: '32px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}
        >
          <Info size={14} style={{ color: 'black' }} />
          <span style={{ color: 'black' }}>
            {buildInfo.version} ({buildInfo.environment})
          </span>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default VersionDisplay;
